import { memo } from "react";
import { InputField, SelectField } from "~/components/Forms";

const CALL_FILTER_OPTIONS = [
	{ value: 'all',       label: 'Tất cả' },
	{ value: 'uncalled',  label: 'Chưa gọi' },
	{ value: '1',         label: 'Đã gọi lần 1' },
	{ value: '2',         label: 'Đã gọi lần 2' },
	{ value: '3',         label: 'Đã gọi lần 3' },
	{ value: '4',         label: 'Đã gọi lần 4' },
	{ value: '5',         label: 'Đã gọi lần 5' },
	{ value: '6',         label: 'Đã gọi lần 6' },
	{ value: '6+',        label: 'Hơn 6 lần' },
	{ value: 'appointed', label: 'Có hẹn' },
];

function Stat({ label, value, color }) {
	return (
		<div style={{ textAlign: 'center', padding: '0 14px', borderLeft: '1px solid #eee' }}>
			<div style={{ color: '#888', fontSize: 12 }}>{label}</div>
			<div style={{ fontSize: 18, fontWeight: 700, color: color || '#222', lineHeight: 1.2 }}>{value}</div>
		</div>
	);
}

function CallSourceSearchBar({ filter, stats, onChange, onSearchChange }) {

	const total    = stats?.total ?? 0;
	const called   = stats?.called ?? 0;
	const uncalled = Math.max(total - called, 0);

	const handleKeywordChange = (e) => {
		if (!onSearchChange) return;
		onSearchChange({ ...filter, keyword: e.target.value, page: 1 });
	};

	const handleFilterChange = (value) => {
		if (!onChange) return;
		onChange({ ...filter, callFilter: value, page: 1 });
	};

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off" style={{ alignItems: 'center' }}>
					<InputField defaultValue={filter.keyword} placeholder="Tên hoặc số điện thoại" onChange={handleKeywordChange} />
					<SelectField value={filter.callFilter || 'all'} placeholder="Trạng thái gọi" options={CALL_FILTER_OPTIONS} onChange={handleFilterChange} />
					<div className="d-flex align-items" style={{ marginLeft: 'auto' }}>
						<Stat label="Tổng số nguồn" value={total} color="#1677ff" />
						<Stat label="Đã gọi" value={called} color="#52c41a" />
						<Stat label="Chưa gọi" value={uncalled} color="#fa8c16" />
					</div>
				</form>
			</div>
		</div>
	);
}

export default memo(CallSourceSearchBar);
